/* Ponto de entrada. Liga as telas, os filtros e a navegação. */
import "./estilo/base.css";
import "./estilo/app.css";
import "./estilo/login.css";

import { sb, configurado } from "./supabase.js";
import { S } from "./estado.js";
import { $, $$, toast, live } from "./util.js";
import { MAPA } from "./dados/especies.js";
import { captadores } from "./estado.js";
import { ligarLogin, mostrarTravado } from "./auth.js";
import { carregarPerfil } from "./api/perfis.js";
import { carregar, escutar } from "./api/casos.js";
import { definirDesenho } from "./render.js";
import { renderQuadro } from "./ui/quadro.js";
import { renderCasos } from "./ui/tabela.js";
import { renderEspecies } from "./ui/especies.js";
import { renderFinanceiro, atualizarSeloGanho } from "./ui/financeiro.js";
import { abrirFicha } from "./ui/ficha.js";
import { copiarTabela } from "./ui/exportar.js";
import { ligarPWA } from "./pwa.js";
import { abrirPix } from "./ui/pix.js";
import { trocarPorLogo, NOME_PAINEL } from "./marca.js";

/* Sem chaves no .env, mostra o passo a passo em vez de uma tela quebrada. */
if (!configurado){
  $("#telaSetup").hidden = false;
  throw new Error("Faltam VITE_SUPABASE_URL e VITE_SUPABASE_ANON no .env");
}

/* Desenha a aba atual. Chamada depois de qualquer mudança de dado ou filtro. */
export function render(){
  $("#vQuadro").hidden     = S.view !== "quadro";
  $("#vCasos").hidden      = S.view !== "casos";
  $("#vEspecies").hidden   = S.view !== "especies";
  $("#vFinanceiro").hidden = S.view !== "financeiro";
  $("#barCasos").hidden  = S.view === "especies" || S.view === "financeiro";
  $("#barEsp").hidden    = S.view !== "especies";
  $("#fab").style.display = (S.view === "especies" || S.view === "financeiro") ? "none" : "";
  $("#fCap").hidden = !S.souAdmin;
  $("#btnPix").hidden = !S.perfil;
  $("#nQuadro").textContent = S.casos.length || "";
  if (S.souAdmin) atualizarSelectCap();

  if (S.view === "quadro")   renderQuadro();
  if (S.view === "casos")    renderCasos();
  if (S.view === "especies")   renderEspecies();
  if (S.view === "financeiro") renderFinanceiro();
}
definirDesenho(render);

function atualizarSelectCap(){
  $("#fCap").innerHTML = `<option value="">Todos os captadores</option>` +
    captadores().map(n => `<option value="${n}" ${n === S.filtroCap ? "selected" : ""}>${n}</option>`).join("");
}

function irPara(v){
  S.view = v;
  $$(".tab").forEach(t => t.setAttribute("aria-selected", t.dataset.view === v));
  $$("#navbot button").forEach(t => t.setAttribute("aria-selected", t.dataset.view === v));
  window.scrollTo({ top: 0 });
  render();
}

/* ---- eventos da barra e da navegação ---- */
$$(".tab, #navbot button").forEach(t => t.addEventListener("click", () => irPara(t.dataset.view)));
$("#buscaCaso").addEventListener("input", e => { S.buscaCaso = e.target.value; render(); });
$("#buscaEsp").addEventListener("input",  e => { S.buscaEsp  = e.target.value; renderEspecies(); });
$("#fPend").addEventListener("click", e => {
  S.filtroPend = !S.filtroPend;
  e.currentTarget.setAttribute("aria-pressed", S.filtroPend);
  render();
});
$("#fCap").addEventListener("change", e => { S.filtroCap = e.target.value; render(); });
$$("[data-fesp]").forEach(b => b.addEventListener("click", () => {
  S.filtroEsp = b.dataset.fesp;
  $$("[data-fesp]").forEach(x => x.setAttribute("aria-pressed", x === b));
  renderEspecies();
}));
$("#btnNovo").addEventListener("click", () => abrirFicha());
$("#fab").addEventListener("click",     () => abrirFicha());
$("#btnCopiar").addEventListener("click", copiarTabela);
$("#btnPix").addEventListener("click", abrirPix);
window.addEventListener("resize", () => { if (S.view === "casos") renderCasos(); });
document.addEventListener("visibilitychange", () => {
  if (!document.hidden && S.iniciado) carregar();
});

/* ---- arranque ---- */
async function entrar(){
  $("#telaLogin").hidden = true;
  if (S.iniciado){ $("#telaApp").hidden = false; return; }
  S.iniciado = true;

  /* Se o perfil falhar, o app segue: o RLS continua protegendo os dados,
     e é melhor mostrar o quadro do que uma tela em branco. */
  try { await carregarPerfil(); }
  catch (e){ console.error("perfil:", e); toast("Não consegui ler seu perfil. Seguindo como captador."); }

  /* Conta criada sem convite consumido. O banco não deixa essa pessoa ver
     nada, então o quadro vazio só confundiria: melhor explicar e oferecer o
     campo do código. ativo indefinido é banco sem a migração 005, e nesse
     caso ninguém fica travado. */
  if (S.perfil?.ativo === false){
    S.iniciado = false;
    mostrarTravado();
    return;
  }

  $("#telaApp").hidden = false;

  try { await carregar(); }
  catch (e){ console.error("casos:", e); live(false,"sem conexão"); toast("Falha ao carregar: "+(e.message||e)); }

  render();
  escutar();
  atualizarSeloGanho();
}

/* O lettering em texto e o que aparece por padrao. Se o arquivo da logo
   existir, ele toma o lugar; se nao existir, ninguem percebe. */
trocarPorLogo($("#marcaPainel"), NOME_PAINEL);
trocarPorLogo($("#marcaEntrada"), NOME_PAINEL);

ligarPWA();
ligarLogin(entrar);
